const LATENCY_ENDPOINT = 'https://balancer.api4com.com/latency-test-path'
const SAMPLE_COUNT = 20
const SAMPLE_TIMEOUT_MS = 2000

const TOTAL_DURATION_MS = 10000
const SAMPLE_INTERVAL_MS = TOTAL_DURATION_MS / SAMPLE_COUNT

const FAILURE_LOSS_THRESHOLD = 50

function sleep (ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

const COLOR_GREEN_THRESHOLDS = { latency: 130, jitter: 30, loss: 1 }
const COLOR_YELLOW_THRESHOLDS = { latency: 150, jitter: 60, loss: 5 }

function classifyColor (latency, jitter, loss) {
  if (latency < COLOR_GREEN_THRESHOLDS.latency && jitter < COLOR_GREEN_THRESHOLDS.jitter && loss < COLOR_GREEN_THRESHOLDS.loss) {
    return 'green'
  }
  if (latency <= COLOR_YELLOW_THRESHOLDS.latency && jitter <= COLOR_YELLOW_THRESHOLDS.jitter && loss <= COLOR_YELLOW_THRESHOLDS.loss) {
    return 'yellow'
  }
  return 'red'
}

async function singleSample () {
  const controller = new AbortController()
  const timer = setTimeout(() => controller.abort(), SAMPLE_TIMEOUT_MS)
  const start = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now()
  try {
    // HEAD em no-cors: só queremos o tempo de round-trip. Sem body, sem CORS,
    // resposta opaca. Status (404/405) não importa — o que vale é a resposta chegar.
    await fetch(`${LATENCY_ENDPOINT}?t=${Date.now()}`, {
      method: 'HEAD',
      cache: 'no-store',
      signal: controller.signal,
      mode: 'no-cors'
    })
    const end = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now()
    return end - start
  } finally {
    clearTimeout(timer)
  }
}

export const NETWORK_TEST_SAMPLE_COUNT = SAMPLE_COUNT
export const NETWORK_TEST_ESTIMATED_TOTAL_SEC = TOTAL_DURATION_MS / 1000

export async function runNetworkTest ({ onProgress } = {}) {
  const samples = []
  let failureCount = 0
  let earlyAbort = false
  const now = (typeof performance !== 'undefined' && performance.now) ? () => performance.now() : () => Date.now()
  const startedAt = now()
  const minSamplesBeforeAbort = Math.ceil(SAMPLE_COUNT / 2)

  for (let i = 0; i < SAMPLE_COUNT; i++) {
    const targetStart = i * SAMPLE_INTERVAL_MS
    const elapsed = now() - startedAt
    const waitBefore = targetStart - elapsed
    if (waitBefore > 0) await sleep(waitBefore)

    try {
      samples.push(await singleSample())
    } catch (_) {
      failureCount++
    }
    if (typeof onProgress === 'function') {
      onProgress({ completed: i + 1, total: SAMPLE_COUNT })
    }

    const done = i + 1
    if (done >= minSamplesBeforeAbort) {
      const currentLossPct = (failureCount / done) * 100
      if (currentLossPct > FAILURE_LOSS_THRESHOLD) {
        earlyAbort = true
        break
      }
    }
  }

  const samplesAttempted = samples.length + failureCount
  const denominator = earlyAbort ? samplesAttempted : SAMPLE_COUNT
  const lossPct = (failureCount / denominator) * 100
  const roundedLoss = Math.round(lossPct * 100) / 100

  if (samples.length === 0 || lossPct > FAILURE_LOSS_THRESHOLD) {
    return {
      color: 'error',
      latencyMs: null,
      jitterMs: null,
      packetLossPct: roundedLoss
    }
  }

  const latency = samples.reduce((sum, s) => sum + s, 0) / samples.length

  let jitterSum = 0
  for (let i = 1; i < samples.length; i++) {
    jitterSum += Math.abs(samples[i] - samples[i - 1])
  }
  const jitter = samples.length > 1 ? jitterSum / (samples.length - 1) : 0

  return {
    color: classifyColor(latency, jitter, lossPct),
    latencyMs: Math.round(latency),
    jitterMs: Math.round(jitter),
    packetLossPct: roundedLoss
  }
}



// WEBPACK FOOTER //
// ./src/services/networkTest.js